import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Spinner,
  Toast,
  Toaster,
  useToastController,
  Text,
} from "@fluentui/react-components";
import {
  Checkmark24Regular,
  ArrowClockwise24Regular,
} from "@fluentui/react-icons";
import AdminService from "./AdminService";
import { useAdminAuth } from "./AdminAuthContext";


export default function CallRecordSubscriptionButton() {
  const { userInfo } = useAdminAuth();


  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);


  const toasterId = "subscription-toaster";
  const { dispatchToast } = useToastController(toasterId);


  // 🔹 Check existing subscription
  useEffect(() => {
    if (!userInfo?.tenantId) return;


    const checkSubscription = async () => {
      try {
        setChecking(true);


        const res = await AdminService.getCallRecordSubscription();
        console.log("res getCallRecordSubscription", res);


        const isCreated = res?.isCreated || false;
        const count = res?.count || 0;
        if (isCreated || Number(count) > 0) {
          setIsSubscribed(true);
        } else {
          setIsSubscribed(false);
        }
      } catch (err) {
        console.error("Subscription check failed:", err);
        setIsSubscribed(false);
      } finally {
        setChecking(false);
      }
    };


    checkSubscription();
  }, [userInfo]);


  // 🔹 Create subscription
  const handleSubscribe = async () => {
    try {
      setLoading(true);


      const res = await AdminService.postCallRecordSubscription(
        3, // expirationInDays
      );
      console.log("res postCallRecordSubscription", res);


      if (res?.subscription) {
        setIsSubscribed(true);


        dispatchToast(<Toast>Subscription created successfully ✅</Toast>, {
          intent: "success",
        });
      }
    } catch (err) {
      console.error("Subscription creation failed:", err);


      dispatchToast(<Toast>Failed to create subscription ❌</Toast>, {
        intent: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  // 🔹 Refresh subscription status
  const handleRefresh = async () => {
    try {
      setLoading(true);
      // refresh call record API
      const res = await AdminService.refreshCallRecordSubscription();
      console.log("res refresh Call RecordSubscription", res);


      if (res?.message) {
        setIsSubscribed(true);


        dispatchToast(
          <Toast>Call Record Subscription refreshed successfully✅</Toast>,
          {
            intent: "success",
          },
        );
      }
    } catch (err) {
      console.error("Subscription creation failed:", err);


      dispatchToast(
        <Toast>Failed to Refresh Call Record Subscription❌</Toast>,
        {
          intent: "error",
        },
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Toaster toasterId={toasterId} />


      <Text>Unaric Voice for Teams Sync - Call Record Subscription</Text>


      {checking ? (
        <Spinner size="tiny" />
      ) : !isSubscribed ? (
        // 🔹 Subscribe Button
        <Button
          appearance="primary"
          onClick={handleSubscribe}
          disabled={loading}
          icon={<Checkmark24Regular />}
        >
          {loading ? "Creating..." : "Subscribe"}
        </Button>
      ) : (
        // 🔹 Refresh Button (shown only when subscribed)
        <Button
          appearance="secondary"
          onClick={handleRefresh}
          disabled={loading}
          icon={<ArrowClockwise24Regular />}
        >
          {loading ? "Refreshing..." : "Refresh"}
        </Button>
      )}
    </>
  );
}
